// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ApplicationCard_wrapper__3va9Q","image":"ApplicationCard_image__Rw1WI","note":"ApplicationCard_note__3q5dM","title":"ApplicationCard_title__WASeE"};